import { Checkbox, RadioInput } from '@mm/components';
import { useFormikContext } from 'formik';
import React from 'react';
import * as yup from 'yup';
import TextInput from '../../../../../../common/components/TextInput';
import './CancelQuestionary.pcss';

export const initialPollValues = {
  reason: undefined,
  feedback: '',
  isUnderstandingConsequences: false,
};

export const questionaryValidator = yup.object({
  reason: yup.string().required(),
  feedback: yup.string(),
  isUnderstandingConsequences: yup
    .bool()
    .oneOf([true], 'Field must be checked')
    .required(),
});

type Poll = yup.Asserts<typeof questionaryValidator>;

const reasons = [
  "I couldn't figure it out",
  "I'm using another service",
  "I couldn't get any contacts",
  "I need features Customers.ai doesn't support",
  "I'm having technical problems",
  "I don't use it enough",
  "It's too expensive",
  'Other (please specify)',
];

export const CancelQuestionary = () => {
  const formik = useFormikContext<Poll>();

  return (
    <div className="cancel-questionary__container">
      <div className="cancel-questionary__block">
        <div className="cancel-questionary__question">
          Please share with us the reasons why you are leaving:
        </div>
        <div>
          {reasons.map((r, idx) => (
            <RadioInput
              key={idx}
              checked={formik.values.reason === r}
              name={r}
              value={r}
              label={r}
              onChange={e => formik.setFieldValue('reason', e.target.value)}
            />
          ))}
        </div>
      </div>

      <div className="cancel-questionary__block">
        <div className="cancel-questionary__question">
          Please help us to be better. Share your experience with Customers.ai
        </div>
        <div className="cancel-questionary__feedback">
          <TextInput
            value={formik.values.feedback}
            onChange={v => formik.setFieldValue('feedback', v.target.value)}
            multiline
            autosize={false}
          />
        </div>
      </div>
      <div className="cancel-questionary__understanding">
        <Checkbox
          isChecked={formik.values.isUnderstandingConsequences}
          onToggle={() =>
            formik.setFieldValue(
              'isUnderstandingConsequences',
              !formik.values.isUnderstandingConsequences,
            )
          }
        />
        I understand that I will lose all of my customers, all of my contacts,
        and all my funnels.
      </div>
    </div>
  );
};
